import { render, staticRenderFns } from "./CustomerReferrals.vue?vue&type=template&id=42bb6e61&scoped=true&"
import script from "./CustomerReferrals.vue?vue&type=script&lang=js&"
export * from "./CustomerReferrals.vue?vue&type=script&lang=js&"
import style0 from "./CustomerReferrals.vue?vue&type=style&index=0&id=42bb6e61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bb6e61",
  null
  
)

export default component.exports